import React from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { Testimonials, initialTestimonials, moreTestimonials } from './components/Testimonials';
import { ProblemSection } from './components/ProblemSection';
import { ModulesGrid } from './components/ModulesGrid';
import { IncludesChecklist } from './components/IncludesChecklist';
import { CountdownUrgency } from './components/CountdownUrgency';
import { Pricing } from './components/Pricing';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotification } from './components/PurchaseNotification';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-[#fdfbf7] font-sans text-[#2c3e2d] selection:bg-[#d4af37] selection:text-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <SocialProof data-id="element-4" />
        <Testimonials testimonials={initialTestimonials} title="💬 LO QUE DICEN LOS DOCENTES QUE YA LO USAN" data-id="element-5" />
        <ProblemSection data-id="element-6" />
        <CostComparison data-id="element-7" />
        <ModulesGrid data-id="element-8" />
        <IncludesChecklist data-id="element-9" />
        <CountdownUrgency data-id="element-10" />
        <Pricing data-id="element-11" />
        <Testimonials testimonials={moreTestimonials} title="💬 LO QUE DICEN LOS DOCENTES QUE YA TIENEN SU MEGAPACK" data-id="element-12" />
        <GuaranteeSection data-id="element-13" />
        <FAQ data-id="element-14" />
        <FinalCTA data-id="element-15" />
      </main>

      <Footer data-id="element-16" />
      <PurchaseNotification data-id="element-17" />
    </div>;
}